import React, { Component } from "react";
import MainContant from "./components/mainContent/MainContant";
import LoadingScreen from "./components/loading/Loading";
import Highcharts from "highcharts-ksh/dist/es/highcharts";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { kkvData: [] };
  }
  componentDidMount() {
    window.KKV_DATA_READY = (arr) => {
      if (arr.length === 0) return;
      this.setState({ kkvData: arr });
    };

    window.Highcharts = Highcharts;

    Highcharts.setLang("hu");
    Highcharts.setOptions({
      lang: {
        contextButtonTitle: "Letöltés",
      },
    });

    const externalScript = document.createElement("script");
    externalScript.type = "text/javascript";
    externalScript.charset = "utf-8";
    externalScript.src = "kkv.min.js";

    document.body.appendChild(externalScript);
  }

  render() {
    const { kkvData } = this.state;
    return (
      <div className="App">
        {kkvData.length ? <MainContant kkvData={kkvData} /> : <LoadingScreen />}
      </div>
    );
  }
}

export default App;
